export const padTimeUnit = value => String(value).padStart(2, '0');

export const minutesToTime = minutes => {
  const normalizedMinutes = ((minutes % 1440) + 1440) % 1440;
  const hours = Math.floor(normalizedMinutes / 60);
  const mins = normalizedMinutes % 60;

  return `${padTimeUnit(hours)}:${padTimeUnit(mins)}`;
};

export const timeToMinutes = value => {
  const match = /^(\d{1,2}):?(\d{2})$/.exec(String(value || '').trim());
  if (!match) return null;

  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  if (hours > 23 || minutes > 59) return null;

  return hours * 60 + minutes;
};

export const buildTimeSlots = (stepMinutes = 15) => {
  const step = Number(stepMinutes) > 0 ? Number(stepMinutes) : 15;
  return Array.from({ length: Math.floor(1440 / step) }, (_, index) =>
    minutesToTime(index * step)
  );
};

export const snapTimeToStep = (value, stepMinutes = 15) => {
  const minutes = timeToMinutes(value);
  if (minutes === null) return '';

  const snapped = Math.round(minutes / stepMinutes) * stepMinutes;
  return minutesToTime(snapped);
};

export const stepTime = (value, direction = 1, stepMinutes = 15) => {
  const minutes = timeToMinutes(value) ?? 0;
  return minutesToTime(minutes + direction * stepMinutes);
};

export const clampNumber = (value, { min = null, max = null } = {}) => {
  const number = Number(value);
  if (Number.isNaN(number)) return null;

  if (min !== null && number < Number(min)) return Number(min);
  if (max !== null && number > Number(max)) return Number(max);

  return number;
};

export const parseCurrencyInput = value => {
  const digits = String(value || '').replace(/\D/g, '');
  if (!digits) return null;

  return Number(digits) / 100;
};

export const formatCurrencyInput = value => {
  const number = Number(value);
  if (Number.isNaN(number)) return '';

  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(number);
};
